import { subDays } from 'date-fns/subDays';
import { Field, Form, Formik } from 'formik';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import toast from 'react-hot-toast';
import Select from 'react-select';
import { DateFormatNew } from '../../../constants/date-picker-constant';
import validCharacters from '../../../constants/valid-characters';
import { IAddEditFormProps } from '../../../models/forms/IForm';
import { IReactSelectOption } from '../../../models/ICommon';
import FormikFormDatePicker from '../../../shared-components/FormikFormHandlers/FormikFormDatePicker';
import FormikFormInput from '../../../shared-components/FormikFormHandlers/FormikFormInput';
import { TrayValidationSchema } from '../../../shared-components/FormikFormHandlers/FormikValidationSchema';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Label from '../../../shared-components/label/label';
import ModalFooter from '../../../shared-components/modal/modal-footer';
import { formatMessage } from '../../../translations/format-message';

interface IProps extends IAddEditFormProps<any> {
  allProductOptions: IReactSelectOption[];
  getProductByIdServiceHandler: (productId: number) => void;
  missingOptions: IReactSelectOption[];
}

const AddEditTrayManagementForm = (props: IProps) => {
  return (
    <>
      <Formik
        initialValues={props.initialValues}
        enableReinitialize
        validationSchema={TrayValidationSchema}
        validateOnBlur={false}
        validateOnChange={true}
        onSubmit={async (values) => {
          const product = props.allProductOptions.find(
            (i) => i.label === values.ProductId
          );

          if (!product && props.id < 0) {
            toast.error(formatMessage('prod_id_not_exist'));
            return;
          }

          const productId =
            props.id > 0 ? props.initialValues.ProductId : product.value;

          const date = new Date(values.CustomerDueDate);
          const localDate = new Date(
            date.getTime() - date.getTimezoneOffset() * 60000
          );
          const formattedDate = localDate.toISOString().split('T')[0];
          props.submitHandler({
            ...values,
            CustomerDueDate: formattedDate,
            ProductId: productId,
            ProductName: values.ProductId,
          });
        }}
      >
        {(form) => {
          return (
            <Form className="user-form">
              {props.isLoading && (
                <FormLoader
                  loading={props.isLoading}
                  contained
                />
              )}
              <Modal.Body>
                <div className="row">
                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        required={true}
                        label="tray_id"
                      />
                      <Field
                        data-testid="testTrayId"
                        className="form-control"
                        name="TrayId"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                        disabled={props.id > 0}
                        validcharacter={validCharacters}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="product_id"
                        required={true}
                      />
                      {props.id > 0 ? (
                        <>
                          <Field
                            data-testid="testTrayId"
                            className="form-control"
                            name="ProductName"
                            type="text"
                            placeholder=""
                            as={FormikFormInput}
                            disabled={props.id > 0}
                            validcharacter={validCharacters}
                          />

                          <Field
                            data-testid="testTrayId"
                            className="d-none"
                            name="ProductId"
                            type="number"
                            placeholder=""
                            as={FormikFormInput}
                            disabled={props.id > 0}
                            validcharacter={validCharacters}
                          />
                        </>
                      ) : (
                        <>
                          <Field name="ProductId">
                            {({ field, form }) => {
                              const [showOptions, setShowOptions] =
                                useState(false);
                              const [searchTerm, setSearchTerm] = useState('');

                              const handleSelect = (
                                label: string,
                                value: number
                              ) => {
                                form.setFieldValue(field.name, label); // numeric ProductId
                                setSearchTerm(label); // show label in input
                                setShowOptions(false);
                              };

                              const filteredOptions =
                                props.allProductOptions.filter((opt) =>
                                  opt.label
                                    .toLowerCase()
                                    .includes(searchTerm.toLowerCase())
                                );

                              return (
                                <>
                                  {' '}
                                  <input
                                    type="number"
                                    onFocus={() => setShowOptions(true)}
                                    onBlur={() =>
                                      setTimeout(
                                        () => setShowOptions(false),
                                        200
                                      )
                                    }
                                    autoComplete="off"
                                    className={`form-control ${
                                      (form.submitCount > 0 ||
                                        form.touched.ProductId) &&
                                      form.errors.ProductId
                                        ? 'error'
                                        : ''
                                    }`}
                                    disabled={props.id > 0}
                                    value={searchTerm}
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      setSearchTerm(val);
                                      form.setFieldValue(field.name, val);
                                    }}
                                  />
                                  {showOptions &&
                                    filteredOptions.length > 0 && (
                                      <ul
                                        style={{
                                          listStyle: 'none',
                                          padding: 0,
                                          margin: 0,
                                          border: '1px solid #ccc',
                                          borderRadius: '4px',
                                          position: 'absolute',
                                          top: '100%',
                                          left: 0,
                                          right: 0,
                                          background: '#fff',
                                          zIndex: 10,
                                          maxHeight: '150px',
                                          overflowY: 'auto',
                                        }}
                                      >
                                        {filteredOptions.map((opt, i) => (
                                          <li
                                            key={i}
                                            style={{
                                              padding: '8px',
                                              cursor: 'pointer',
                                              borderBottom: '1px solid #eee',
                                            }}
                                            // onMouseDown={() =>
                                            //   handleSelect(opt.label)
                                            // }
                                            onMouseDown={() =>
                                              handleSelect(
                                                opt.label,
                                                Number(opt.value)
                                              )
                                            }
                                          >
                                            {opt.label}
                                          </li>
                                        ))}
                                      </ul>
                                    )}
                                  {(form.submitCount > 0 ||
                                    form.touched.ProductId) &&
                                    form.errors.ProductId && (
                                      <div className="text-danger errorMessage">
                                        {formatMessage(form.errors.ProductId)}
                                      </div>
                                    )}{' '}
                                </>
                              );
                            }}
                          </Field>
                        </>
                      )}

                      {/* <Field name="ProductId">
                        {({ field, form }) => {
                          const selectedOption = props.allProductOptions.find(
                            (option) => option.value === field.value
                          );

                          return (
                            <CreatableSelect
                              className="select-did-process"
                              classNames={{
                                option: (d) =>
                                  `our-option ${d.isSelected ? 'active' : ''}`,
                              }}
                              options={props.allProductOptions}
                              value={selectedOption}
                              onChange={(option) =>
                                form.setFieldValue(field.name, option.value)
                              }
                              onBlur={() =>
                                form.setFieldTouched(field.name, true)
                              }
                              isDisabled={props.id > 0}
                              formatCreateLabel={(ele) => {
                                return ele;
                              }}
                            />
                          );
                        }}
                      </Field> */}
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="customer_id"
                      />
                      <Field
                        data-testid="testCustomerId"
                        className="form-control"
                        name="CustomerId"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                        validcharacter={validCharacters}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="order_id"
                      />
                      <Field
                        data-testid="testOrderId"
                        className="form-control"
                        name="OrderId"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                        validcharacter={['-']}
                      />
                    </div>
                  </div>
                  <div className="col-5">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="katashiki_1"
                      />
                      <Field
                        data-testid="testKatashiki1"
                        className="form-control"
                        name="Katashiki1"
                        type="text"
                        placeholder=""
                        validcharacter={validCharacters}
                        as={FormikFormInput}
                      />
                    </div>
                  </div>

                  <div className="col-5">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="katashiki_2"
                      />
                      <Field
                        data-testid="testKatashiki2"
                        className="form-control"
                        name="Katashiki2"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                        validcharacter={validCharacters}
                      />
                    </div>
                  </div>

                  <div className="col-2">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="kishu"
                      />
                      <Field
                        data-testid="testKishu"
                        className="form-control"
                        name="Kishu"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                        validcharacter={validCharacters}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="process_name"
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="ProcessName"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                        validcharacter={validCharacters}
                      />
                    </div>
                  </div>
                  <div className="col-2">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="quantity"
                        required={true}
                      />
                      <Field
                        data-testid="testQuantity"
                        className="form-control"
                        name="Quantity"
                        type="number"
                        placeholder=""
                        as={FormikFormInput}
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="quantity_unit_name"
                      />
                      <Field
                        data-testid="testQuantityUnitName"
                        className="form-control"
                        name="QuantityUnitName"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                        validcharacter={validCharacters}
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="invoice_number"
                      />
                      <Field
                        data-testid="testInvoiceNumber"
                        className="form-control"
                        name="InvoiceNumber"
                        type="number"
                        placeholder=""
                        as={FormikFormInput}
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="sub_contractor"
                      />
                      <Field
                        data-testid="testSubContractor"
                        className="form-control"
                        name="SubContractor"
                        type="number"
                        placeholder=""
                        as={FormikFormInput}
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="sub_contractor_name"
                      />
                      <Field
                        data-testid="testSubContractorName"
                        className="form-control"
                        name="SubContractorName"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                        validcharacter={validCharacters}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="customer_due_date"
                        required={true}
                      />
                      <Field
                        data-testid="testCustomerDueDate"
                        className={`form-control ${
                          form.touched.CustomerDueDate &&
                          form.errors.CustomerDueDate
                            ? 'error'
                            : ''
                        }`}
                        name="CustomerDueDate"
                        autoComplete="off"
                        placeholder=""
                        // dateFormat={DateFormatForDatePickerJP}
                        dateFormat={DateFormatNew}
                        minDate={subDays(new Date(), 0)}
                        showOutsideDays={false}
                        as={FormikFormDatePicker}
                        fixedHeight
                      />
                    </div>
                  </div>

                  <div className="col-3">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="end_user_name"
                      />
                      <Field
                        data-testid="testEndUserName"
                        className="form-control"
                        name="EndUserName"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                        validcharacter={validCharacters}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="end_user_order_id"
                      />
                      <Field
                        data-testid="testEndUserOrderId"
                        className="form-control"
                        name="EndUserOrderId"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                        validcharacter={validCharacters}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="missing_parts"
                      />
                      <Field name="MissingParts">
                        {({ field, form }) => {
                          const selectedOption = props.missingOptions.find(
                            (option) => option.value === field.value
                          );

                          return (
                            <Select
                              className="select-did-process"
                              classNames={{
                                option: (d) =>
                                  `our-option ${d.isSelected ? 'active' : ''}`,
                              }}
                              options={props.missingOptions}
                              value={selectedOption}
                              onChange={(option) =>
                                form.setFieldValue(field.name, option.value)
                              }
                              onBlur={() =>
                                form.setFieldTouched(field.name, true)
                              }
                            />
                          );
                        }}
                      </Field>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="product_comment_1"
                      />
                      <Field
                        data-testid="testProductComment1"
                        className="form-control"
                        name="ProductComment1"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                        validcharacter={validCharacters}
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="product_comment_2"
                      />
                      <Field
                        data-testid="testProductComment2"
                        className="form-control"
                        name="ProductComment2"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                        validcharacter={validCharacters}
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="product_comment_3"
                      />
                      <Field
                        data-testid="testProductComment3"
                        className="form-control"
                        name="ProductComment3"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                        validcharacter={validCharacters}
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="product_comment_4"
                      />
                      <Field
                        data-testid="testProductComment4"
                        className="form-control"
                        name="ProductComment4"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                        validcharacter={validCharacters}
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="product_comment_5"
                      />
                      <Field
                        data-testid="testProductComment5"
                        className="form-control"
                        name="ProductComment5"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                        validcharacter={validCharacters}
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        label="product_comment_6"
                      />
                      <Field
                        data-testid="testProductComment6"
                        className="form-control"
                        name="ProductComment6"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                        validcharacter={validCharacters}
                      />
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <ModalFooter
                id={props.id}
                onModalClosed={props.onModalClosed}
                isLoading={props.isLoading}
                saveNextBtn={props.id > 0 ? 'update' : 'save'}
                backCancelBtn="cancel"
              />
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default AddEditTrayManagementForm;
